import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { filter, map, Observable, take } from 'rxjs';
import { Utilityservice } from '../views/utility/utilityservice.service';

@Injectable({
  providedIn: 'root'
})
export class RolegaurdGuard implements CanActivate {
  orgType = "";
  requireVertical = ""; 
  hasLimitedAccess = "";
  orgId = "";
  backupDownloadFlag = "Y";
  requireHub = "";
  requireRegion = "";
  requireSubVertical = ""; 
  requireCity = "";
  requireLocationType = ""; 
  requireSubDepartment = ""; 
  userRole: Number; 
  tssprtlimitedaccess = "N";
  compissupportadmin: string;
  orgStatsUserList: string[] = [
    "3", "7", "10", "480", "9610",
    "13", "14", "8893", "8922", "9615", "13340","11685"
  ];
  userId: string;

  constructor(private utilityservice: Utilityservice, private router: Router) { }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const roleid = this.utilityservice.getUserRights().roleid
    this.utilityservice.fetchAndStoreConfigParams();

    return this.utilityservice.configParams$.pipe(
      filter((res: any) => res !== null),
      take(1),
      map((res: any) => {
        const responseArray = res;
        if (responseArray) {
          const config = responseArray;
          this.userRole = config.genroleid; 
          this.requireVertical = config.requirevertlabel;
          this.requireSubDepartment = config.requiresubdeptlabel;
          this.requireSubVertical = config.requiresubvertlabel; 
          this.requireHub = config.ishub;
          this.requireCity = config.iscity;
          this.requireLocationType = config.islocationtype;
          this.requireRegion = config.isregion; 
          this.orgId = config.orgid;
          this.hasLimitedAccess = config.haslimitedaccess;
          this.orgType = config.orgtype;
          this.backupDownloadFlag = config.backupdownloadflag;
          this.compissupportadmin = config.issupportadmin;
          this.userId = config.userid;
          if (this.hasLimitedAccess == "Y" && this.compissupportadmin == "Y") {
            this.tssprtlimitedaccess = "Y";
          }
          
        }
        if (
          this.orgId == "1" && (state.url == '/common/application-logs' )
        ) {
          return true;
        }
        if (
          this.userRole == 1 && this.tssprtlimitedaccess == 'N' &&
          (state.url == '/common/my-credentials' || state.url == '/common/my-configuration' 
            || state.url == '/common/user-access-mapping' || state.url == '/common/application-configuration'
            || state.url == '/common/user-log-report'
            || state.url == '/common/audit-log'
            || state.url == '/common/e-signature'
            || state.url == '/common/version-update-report'
            || state.url == '/common/common-dashboard'
            || ((this.orgId == "1" || this.orgId == "3458") && state.url == '/common/client-usage-report')
            || (this.orgStatsUserList.includes(this.userId) && state.url == '/common/organisation-statistics' )
          )
        ) {
          return true;
        }
        if (
          this.userId == "0" &&
          (state.url == '/common/remove-organisation' || state.url == '/common/entity-type' || state.url == '/common/state'
            || state.url == '/common/application-configuration'
            || state.url == '/common/client-usage-report'
            || state.url == '/common/schedulerlog'
            || state.url == '/common/version-update-report'
            || state.url == '/common/e-signature'
            || state.url == '/common/login-page-messages'
            || state.url == '/common/organisation-statistics' 
            || state.url == '/common/country')
        ) {
          return true;
        }

        if (
          this.userRole == 1 &&
          (state.url == '/common/invalid-file-extensions' || state.url == '/common/department'  || state.url == '/common/currency'
            || state.url == '/common/financial-year'
            || state.url == '/common/unlicensed-user-master'
            || state.url == '/common/signatory-details'
            || (state.url == '/common/sub-department' && this.requireSubDepartment == 'Y')
            || (state.url == '/common/hub' && this.requireHub == 'Y')
            || (state.url == '/common/help-masters' && this.orgId == '1')
            || (state.url == '/common/city' && this.requireCity == 'Y')
            || (state.url == '/common/vertical' && this.requireVertical == 'Y')
            || (state.url == '/common/client-group' && this.orgType == 'P')
            || (state.url == '/common/region' && this.requireRegion == 'Y')
            || (state.url == '/common/sub-vertical' && this.requireSubVertical == 'Y')
            || (state.url == '/common/location-type' && this.requireLocationType == 'Y' && this.orgType != "P")
          )
        ) {
          return true;
        }

        if (
          (this.userRole == 1 || this.userRole == 0) &&
          (state.url == '/common/entity' || state.url == '/common/location' || state.url == '/common/user' || state.url == '/common/organisation')
        ) {
          return true;
        }

        if (
          (this.userRole == 2 || this.userRole == 3) &&
          (state.url == '/common/my-credentials' || state.url == '/common/my-configuration'
             || state.url == '/common/version-update-report'


          )
        ) {
          return true;
        }

         if (
          (this.userRole == 2  ) &&
          (state.url == '/common/common-dashboard')
        ) {
          return true;
        }

        this.router.navigate(['/not-authorised']);
        return false;
      })
    );
  }

}
